module.exports = "<svg style=\"width: 16px; height: 16px\" viewBox=\"7 7 16 16\"><path d=\"M12.748,11 C12.748,12.104 13.644,13 14.748,13 C15.852,13 16.748,12.104 16.748,11 C16.748,9.896 15.852,9 14.748,9 C13.644,9 12.748,9.896 12.748,11 M10.748,11 C10.748,8.791 12.539,7 14.748,7 C16.957,7 18.748,8.791 18.748,11 C18.748,13.209 16.957,15 14.748,15 C12.539,15 10.748,13.209 10.748,11 M22.496,23 L20.406,23 C19.583,20.67 17.36,19 14.748,19 C12.136,19 9.913,20.67 9.09,23 L7,23 C7.889,19.55 11.02,17 14.748,17 C18.476,17 21.607,19.55 22.496,23\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/user.svg
// module id = 1298
// module chunks = 0